// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__1y6VH","menu":"dropdown_menu__2vlX6","control":"dropdown_control__wzZNo","lg":"dropdown_lg__2VZW4","right":"dropdown_right__uCrnK"};